import PlanManagementPage from './index.vue'
export { PlanManagementPage }
export default PlanManagementPage
